export default __webpack_public_path__ + "static/media/finish.50bf05ca.svg";